
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GpsPosDto, GpsTrackerDto, GpsTrackerUiClient } from '../../../backend/backendapi';
import { handleError, initClient } from '../../../../api';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import GpsTrackerStore from '../../../../stores/GpsTrackerStore';
import { formatDateTime, WindowType } from '../../../../util';
import GpsPositionStore from '../../../../stores/GpsPositionStore';
import Tabs from './Tabs';

declare var window: WindowType;

@Component({
  name: 'GpsTrackerEditModal',
  components: {
    Tabs,
    vSelect,
  },
})
export default class GpsTrackerEditModal extends Vue {
  private readonly gpsPositionStore = new GpsPositionStore();
  private readonly gpsTrackerApi = initClient(GpsTrackerUiClient);
  private readonly gpsTrackerStore = new GpsTrackerStore();

  tracker: GpsTrackerDto | null = null;

  get canEdit(): boolean {
    return window.application.permissions.map.gps.edit;
  }

  get lastPosition(): GpsPosDto | null {
    return this.tracker
        ? this.gpsPositionStore.gpsLastPositions.find(e => e.fkTrackerId === this.tracker?.id) ?? null
        : null;
  }

  get lastPositionUpdate(): string {
    if (this.lastPosition) {
      return formatDateTime(this.lastPosition.timestamp);
    }
    return this.$t('general.unknown').toString();
  }

  get uid(): string {
    return (this as any)._uid;
  }

  async mounted(): Promise<void> {
    await this.gpsPositionStore.loadIfAbsent();
    await this.gpsTrackerStore.loadIfAbsent();
  }

  public open(tracker: GpsTrackerDto): void {
    this.tracker = GpsTrackerDto.fromJS(tracker);
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.tracker = null;
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    if (!this.tracker) {
      return;
    }

    try {
      if (this.tracker.id === 0) {
        const res = await this.gpsTrackerApi.add(this.tracker);
        this.gpsTrackerStore.addGpsTracker(res);
      } else {
        const res = await this.gpsTrackerApi.update(this.tracker);
        this.gpsTrackerStore.updateGpsTracker(res);
      }

      this.$toasted.info(this.$t('txtSaved').toString());
      this.dismiss();
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    }
  }
}
